module.exports = __webpack_public_path__ + "img/speadsheet-icon.d6d8e9b3.svg";